import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleChartLineFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm4.78,6.78l-2.646,2.646c-.486,.487-1.281,.487-1.768,0l-1.616-1.616-2.47,2.47c-.146,.146-.338,.22-.53,.22s-.384-.073-.53-.22c-.293-.293-.293-.768,0-1.061l2.646-2.646c.486-.487,1.281-.487,1.768,0l1.616,1.616,2.47-2.47c.293-.293,.768-.293,1.061,0s.293,.768,0,1.061Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleChartLineFill18.js.map